import { useSelector } from 'react-redux';
import { RootState } from '..';
import { AppSettings } from './appSettings';

export const selectSettings = (state: RootState): AppSettings => state.settings;

export const useSettingsState = () => useSelector(selectSettings);
